import React from 'react';
import styles from './AcfContainer.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import { Container } from '@/components';

let cx = className.bind(styles);

export default function AcfContainer(props) {
	const { attributes, innerBlocks } = props;
	const className = attributes.className?.split(' ') || [];

	function InnerBlocks() {
		return React.createElement(WordPressBlocksViewer, { blocks: innerBlocks !== null && innerBlocks !== void 0 ? innerBlocks : [] });
	}
	return (
		<Container id={attributes.anchor} className={cx([...className])}>
			<InnerBlocks />
		</Container>
	);
}

AcfContainer.fragments = {
	key: `AcfContainerFragment`,
	entry: gql`
		fragment AcfContainerFragment on AcfContainer {
			attributes {
				anchor
				className
			}
		}
	`,
};

AcfContainer.config = {
	name: 'AcfContainer',
};
AcfContainer.displayName = 'AcfContainer';
